<template>
  <div id="mainNav">
    <div
      id="dv-title"
      class="contain-nav-item"
    >
      <template v-if="showSideNavToggler">
        <svg
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          x="0px"
          y="0px"
          width="459px"
          height="459px"
          viewBox="0 0 459 459"
          style="enable-background: new 0 0 459 459"
          xml:space="preserve"
          @click="$emit('togglesidenav')"
        >
          <g>
            <g id="menu">
              <path d="M0,382.5h459v-51H0V382.5z M0,255h459v-51H0V255z M0,76.5v51h459v-51H0z" />
            </g>
          </g>
        </svg>
      </template>

      <div id="dv-user-container">
        <a href="/dv/">Diamondview</a>
        <span>{{ currentUser }}</span>
      </div>
    </div>
    <div
      v-cloak
      id="nav-tabs"
      class="inapp contain-nav-item"
    >
      <!-- Sort tabs by dis order -->
      <template v-for="tab in orderedTabs">
        <dv-nav-dropdown
          :key="tab.id"
          :tab="tab"
        />
      </template>
    </div>
    <!-- spacer -->
    <div
      style="flex-grow: 2"
      class="contain-nav-item hide-mobile"
    />

    <div class="nav-right-section-wrapper contain-nav-item">
      <div class="nav-right-section">
        <div id="dv-universal-search">
          <search
            :search-types="searchTypes"
            :selected-search-type="searchType"
            :search-types-to-auto-open-page="searchTypes"
            :amateur-options="amateurSearchOptions"
            :show-options="showSearchOptions"
            :show-create-player="showCreatePlayer"
            :show-create-school="showCreateSchool"
            align-right
            @newPlayer="(searchType) => $emit('createPlayer', searchType)"
            @newSchool="(searchType) => $emit('createSchool', searchType)"
          />
        </div>
        <div
          id="the-feed-button"
          class="hide-mobile"
        />
        <div id="dv-logout-button">
          <img
            id="DVLogOut"
            src="/dv/images/Icon_Logout.png"
            @click="logout"
          />
        </div>
        <div
          v-if="showScoutviewDv2Link"
          id="dv2-link-scoutview"
          class="dv2-link-scoutview"
        >
          <a
            :href="scoutviewDv2PlayerUrl"
            target="_blank"
            rel="noopener noreferrer"
            title="Open player page in DV2"
          >
            <img
              src="/dv/images/Dv2LinkIcon.svg"
              alt="Open player page in DV2"
            />
          </a>
        </div>
      </div>
    </div>

    <template v-if="securityEdit">
      <security-modal
        ref="securityModal"
        class="contain-nav-item"
      />
    </template>
  </div>
</template>

<script>
import Search from '@baseball-systems/MasterSearch';
import { httpMixin } from 'library/mixins/http';
import { notificationsMixin } from 'library/mixins/notifications';
import { getDvDomain } from 'library/helpers/domainConfig';

import moment from 'moment';
import DVNavDropdown from './DvNavDropdown.vue';
import SecurityModal from './security/SecurityModal.vue';

const SEARCH_TYPES = ['dv', 'pd', 'pro', 'amateur', 'intl'];

export default {
  components: {
    'dv-nav-dropdown': DVNavDropdown,
    search: Search,
    'security-modal': SecurityModal,
  },
  mixins: [notificationsMixin, httpMixin],
  props: {
    appConstantData: {
      type: Object,
      default: () => {},
    },
    showSideNavToggler: {
      type: Boolean,
      default: true,
    },
    searchType: {
      type: String,
      default: 'dv',
      validate: (val) => SEARCH_TYPES.includes(val),
    },
    showSearchOptions: {
      type: Boolean,
      default: false,
    },
    showCreatePlayer: {
      type: Boolean,
      default: false,
    },
    showCreateSchool: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentUser: null,

      canAccessPD: null,
      viewPromotionalModel: null,
      canAccessOrgView: null,
      canAccessTonto: null,
      canAccessAdvance: null,
      canAccessContractView: false,
      canMatchPlayers: false,
      canAccessDraftTools: false,
      opsViewer: null,
      securityEdit: null,
      canViewUpsideModel: false,

      appOrgsData: null,
      cleLastGamesData: null,
      liveGames: null,
      cleTeamsData: null,
      cleVirtualTeamsData: null,
      tabs: [],
      amateurSearchOptions: {
        allowSchoolSearch: true,
        amateurSvcInt: 0,
        includeCol: true,
        includeHS: true,
        yearFlag: 5,
        year: new Date().getFullYear(),
      },

      searchTypes: SEARCH_TYPES,
    };
  },
  computed: {
    orderedTabs: function () {
      return this.tabs.sort((a, b) => {
        return a.sortPosition - b.sortPosition;
      });
    },
    /**
     * Scout View (scouting_new) player routes use `/player/:playerId` under base `/dv/scouting_new`.
     * Mirrors dview `PlayerPage` DV2 link target.
     */
    scoutviewDv2PlayerUrl() {
      const route = this.$route;
      if (!route?.params?.playerId || !route.path?.startsWith('/player/')) {
        return '';
      }
      return `https://dv.bb.guardiansfrontoffice.com/#/player/${route.params.playerId}`;
    },
    showScoutviewDv2Link() {
      return !!this.scoutviewDv2PlayerUrl && this.canViewUpsideModel;
    },
  },
  watch: {
    // set data when it becomes available from the parent shell component
    appConstantData: function (acd) {
      this.currentUser = acd.UserName;
      this.canAccessPD = acd.Permissions.indexOf('CanAccessPD') > -1;
      this.viewPromotionalModel = acd.Permissions.indexOf('ViewPromotionalModel') > -1;
      this.canAccessOrgView = acd.Permissions.indexOf('CanAccessOrgView') > -1;
      this.canAccessTonto = acd.Permissions.indexOf('CanAccessTonto') > -1;
      this.canAccessAdvance = acd.Permissions.indexOf('CanAccessAdvance') > -1;
      this.opsViewer = acd.Permissions.indexOf('OpsViewer') > -1;
      this.securityEdit = acd.Permissions.indexOf('SecurityEdit') > -1;
      this.canAccessContractView = acd.Permissions.indexOf('ContractCalculator') > -1;
      this.canMatchPlayers = acd.Permissions.indexOf('MatchPlayers') > -1;
      this.canAccessDraftTools = acd.Permissions.indexOf('DraftServices') > -1;
      this.canAccessFxwOBAfxFIP = acd.Permissions.indexOf('DVCanSeefxwOBAfxFIP') > -1;
      this.canViewUpsideModel = acd.Permissions.indexOf('ViewUpsideModel') > -1;

      this.setupNavTabs();
    },
  },
  mounted() {
    const thefeed = new TheFeed();
    thefeed.makeButton(document.getElementById('the-feed-button'));
  },
  methods: {
    logout() {
      window.location = '/dv/login.html';
    },
    setupNavTabs() {
      this.tabs = [];

      if (this.canAccessPD) {
        const getPdTeamList = () =>
          this.request('/dvsvc/PDTeamList/').then((resp) => {
            if (resp.IsError) {
              this.notifyDanger('Error: PDTeamList service');
              return;
            }
            this.cleTeamsData = resp;
          });

        const getVirtualRoster = () => {
          // setting up virtual roster links
          const StartDt = moment(new Date()).subtract(14, 'day').format('YYYY-MM-DD');
          const EndDt = moment(new Date()).add(7, 'day').format('YYYY-MM-DD');

          return this.request(`/dvsvc/RstVirtualForDates?FromDt=${StartDt}&ToDt=${EndDt}`).then((resp) => {
            if (resp.IsError) {
              this.notifyDanger('Error: PDVirtualRosterTeamList service');
              return;
            }
            this.cleVirtualTeamsData = resp.Teams;
          });
        };

        Promise.all([getPdTeamList(), getVirtualRoster()]).finally(() => this.createPDevTabs());
      }
      if (this.canAccessOrgView) {
        this.createLeagueViewTabs();

        this.request('/dvsvc/AppOrganizations/').then((resp) => {
          if (resp.IsError) {
            this.notifyDanger('Error: AppOrganizations service');
            return;
          }
          this.appOrgsData = resp;
          this.createOrgViewTabs();
        });

        this.request('/dvsvc/LvAllLists').then((resp) => {
          if (resp.IsError) {
            this.notifyDanger('Error: LvAllLists service');
            return;
          }

          this.createListViewTabs(resp);
        });
      }
      if (this.canAccessTonto || this.canAccessAdvance) {
        this.createScoutingTabs();
      }
      Promise.all([
        this.request('/dvsvc/CleGamesLastPlayed/').then((resp) => {
          if (resp.IsError) {
            this.notifyDanger('Error: CleGamesLastPlayed service');
            return;
          }
          this.cleLastGamesData = resp;
        }),
        this.request('/dvsvc/LvGmsByDate/').then((resp) => {
          if (resp.IsError) {
            this.notifyDanger('Error: LvGmsByDate service');
            return;
          }
          this.liveGames = resp;
        }),
      ]).then(() => {
        this.createGamesTabs();
      });

      if (this.opsViewer || this.securityEdit) {
        this.createOptionsLink();
      }
    },
    createPDevTabs() {
      const sections = [];

      // Affiliates -------------------------------------------------
      const affiliates = this.cleTeamsData
        .sort((a, b) => {
          return a.DisplayOrder - b.DisplayOrder;
        })
        .map((tm) => {
          return {
            // id name link target
            id: tm.TmID,
            text: tm.Nickname,
            link: '/dv/pdev/index.html?TmID=' + tm.TmID,
            target: '_self',
          };
        });
      const indians = this.cleTeamsData.find((tm) => tm.Rank === 1);

      const affiliateSection = {
        id: 'affiliates',
        text: 'affiliates',
        items: affiliates,
      };

      sections.push(affiliateSection);

      // Virtual Rosters -------------------------------------------------
      const virtualRosters =
        this.cleVirtualTeamsData
          ?.sort((a, b) => {
            return a.Name < b.Name ? -1 : 1;
          })
          ?.map((tm) => {
            return {
              // id name link target
              id: tm.VTmID,
              text: tm.Name,
              link: '/dv/pdev/index.html?TmID=' + tm.VTmID,
              target: '_self',
            };
          }) || [];

      const virtualRosterSection = {
        id: 'virtualRosters',
        text: 'virtual rosters',
        items: virtualRosters,
      };
      sections.push(virtualRosterSection);

      // Report Reader ---------------------------------------------
      const reportReaderSection = {
        id: 'report-reader',
        text: 'Report Reader',
        items: [
          {
            id: 'process-reports',
            text: 'Notes',
            link: `/dv/pdev/index.html?TmID=${indians.TmID}#all-process-notes`,
            target: '_self',
          },
          {
            id: 'coordinator-reports',
            text: 'Coordinator Reports',
            link: `/dv/pdev/index.html?TmID=${indians.TmID}#all-coordinator-reports`,
            target: '_self',
          },
          {
            id: 'gps-reports',
            text: 'GPS Reports',
            link: `/dv/pdev/index.html?TmID=${indians.TmID}#all-gps-reports`,
            target: '_self',
          },
          {
            id: 'physical-dash',
            text: 'Physical Dashboard',
            link: `/dv/pdev/index.html?TmID=${indians.TmID}#org-view-physical-dash`,
            target: '_self',
          },
        ],
      };
      sections.push(reportReaderSection);

      // Roster ---------------------------------------------------
      const rosterItems = [];

      if (this.viewPromotionalModel) {
        rosterItems.push({
          id: 'promotion-model',
          text: 'Promotion Model',
          link: '/dv/pdev/#promotion-model',
          target: '_self',
        });
      }

      rosterItems.push({
        id: 'milb-roster-board',
        text: 'MnL Roster Board',
        link: `${getDvDomain()}/#/coaches/all-affiliates/mnl-roster-board`,
        target: '_blank',
      });
      rosterItems.push({
        id: 'roster-manager',
        text: 'Virtual Roster',
        link: '/dv/pdev/#virtual-rosters',
        target: '_blank',
      });

      const rosterSection = {
        id: 'roster',
        text: 'Roster',
        items: rosterItems,
      };

      sections.push(rosterSection);

      // Managers -----------------------------------------
      const bpManSection = {
        id: 'managers',
        text: 'Managers',
        items: [
          {
            id: 'manage',
            text: 'Bullpen Manager',
            link: '/dv/dview/bp.html',
            target: '_blank',
          },
          {
            id: 'evt-manage',
            text: 'Event Manager',
            link: '/dv/eventManager/index.html',
            target: '_blank',
          },
          {
            id: 'file-manage',
            text: 'DOBY Manager',
            link: '/dv/filemanager/#/list',
            target: '_blank',
          },
          // {
          //     id: 'roster-mange',
          //     text: 'Roster Manager',
          //     link: '/dv/rosterManager/index.html',
          //     target: '_blank'
          // },
        ],
      };

      sections.push(bpManSection);

      // PDev Tab
      let pDevTabs = {
        sortPosition: 1,
        id: 'Teams',
        text: 'Coach View',
        img: '/dv/images/app-icons/PDev_small.png',
        sections: sections,
      };
      this.tabs.push(pDevTabs);
    },
    createLeagueViewTabs() {
      let decisionToolsSectionItems = [
        {
          id: 'conversations',
          text: 'Conversations',
          link: '/dv/conv/index.html',
          target: '_self',
        },
        {
          id: 'team-needs',
          text: 'Team Needs',
          link: '/dv/decisions/#/',
          target: '_self',
        },
        {
          id: 'offer-tracker',
          text: 'Offer Tracker',
          link: '/dv/decisions/#/offer-tracker',
          target: '_self',
        },
        {
          id: 'available-players',
          text: 'Available Players',
          link: '/dv/decisions/#/available-players',
          target: '_self',
        },
        {
          id: 'players-packages',
          text: 'Players & Packages',
          link: '/dv/decisions/#/player-adj',
          target: '_self',
        },
        ...(this.canAccessContractView
          ? [
              {
                id: 'contract-view',
                text: 'Contract View',
                link: '/dv/decisions/#/contract-view',
                target: '_self',
              },
            ]
          : []),
        {
          id: 'dfas',
          text: 'Waivers & DFA Limbo',
          link: '/dv/decisions/#/dfas',
          target: '_self',
        },
      ];

      const sections = [
        {
          id: 'league-view',
          text: 'League View',
          items: [
            {
              id: 'overview',
              text: 'Team Overview',
              link: '/dv/league/index.html#TeamOverview',
              target: '_self',
            },
            {
              id: 'outlook',
              text: 'Team Outlook',
              link: '/dv/league/index.html#TeamOutlook',
              target: '_self',
            },
            {
              id: 'valuations',
              text: 'Team Valuations',
              link: '/dv/league/index.html#TeamValuations',
              target: '_self',
            },
            {
              id: 'stats',
              text: 'Team Stats',
              link: '/dv/league/index.html#TeamStats',
              target: '_self',
            },
            {
              id: 'leaderboard',
              text: 'Leaderboard',
              link: '/dv/league/index.html#Leaderboard',
              target: '_self',
            },
            {
              id: 'rosterboard',
              text: 'Roster Board',
              link: '/dv/league/index.html#RosterBoard',
              target: '_self',
            },
            {
              id: 'team-financials',
              text: 'Team Financials',
              link: '/dv/league/index.html#TeamFinancials',
              target: '_self',
            },
            {
              id: 'player-financials',
              text: 'Player Financials',
              link: '/dv/league/index.html#PlayerFinancials',
              target: '_self',
            },
            {
              id: 'transactions',
              text: 'Transactions',
              link: '/dv/league/index.html#Transactions',
              target: '_self',
            },
            {
              id: 'grids',
              text: 'Grids',
              link: '/dv/league/index.html#Grids',
              target: '_self',
            },
          ],
        },
        {
          id: 'decision-tools',
          text: 'Decision Tools',
          items: decisionToolsSectionItems,
        },
      ];

      const leagueViewTabs = {
        sortPosition: 2,
        id: 'league-view',
        text: 'League View',
        img: '/dv/images/app-icons/LeagueView_small.png',
        sections: sections,
      };

      this.tabs.push(leagueViewTabs);
    },
    createOrgViewTabs() {
      // can access stuf
      const divisions = [
        {
          text: 'AL Central',
          league: 'A',
          division: 'C',
          teams: [],
        },
        {
          text: 'NL Central',
          league: 'N',
          division: 'C',
          teams: [],
        },
        {
          text: 'AL East',
          league: 'A',
          division: 'E',
          teams: [],
        },
        {
          text: 'NL East',
          league: 'N',
          division: 'E',
          teams: [],
        },
        {
          text: 'AL West',
          league: 'A',
          division: 'W',
          teams: [],
        },
        {
          text: 'NL West',
          league: 'N',
          division: 'W',
          teams: [],
        },
      ];
      const sections = [];

      divisions.forEach((d) => {
        const divOrgs = this.appOrgsData
          .filter((o) => d.league === o.League && d.division === o.Division)
          .sort((a, b) => {
            if (a.Nickname < b.Nickname) {
              return -1;
            } else if (a.Nickname < b.Nickname) {
              return 1;
            } else {
              return 0;
            }
          });

        const items = divOrgs.map((o) => {
          return {
            id: o.OrgID,
            text: o.Nickname,
            link: '/dv/orgs/overview?oid=' + o.OrgID,
            target: '_self',
          };
        });
        const section = {
          id: d.league + d.division,
          text: d.text,
          items: items,
        };
        sections.push(section);
      });

      let orgViewTabs = {
        sortPosition: 3,
        id: 'org-view',
        text: 'Org View',
        img: '/dv/images/app-icons/OrgView_small.png',
        sections: sections,
        cols: 2, // flag to display in two columns
      };
      this.tabs.push(orgViewTabs);
    },
    createListViewTabs(lists) {
      const mapListViewItems = (lists) =>
        lists.map((l) => {
          return {
            id: l.ListID,
            text: l.Name,
            link: `/dv/list-view/?lid=${l.ListID}`,
            target: '_self',
          };
        });

      const { recentlyCreated, recentlyOpened } = this.mapListViewLists(lists?.Lists || []);

      const newListViewSection = {
        id: 'new-list-view',
        text: 'List View',
        items: [
          {
            id: 'new-list-view-open',
            text: 'Dashboard',
            link: '/dv/list-view',
            target: '_blank',
          },
          {
            id: 'list-view-open-search-lists',
            text: 'Search Lists',
            link: '/dv/list-view/?newTab=search',
            target: '_self',
          },
          {
            id: 'list-view-open-create-lists',
            text: 'Create New List',
            link: '/dv/list-view/?newTab=create',
            target: '_self',
          },
          {
            id: 'list-view-quick-create-list',
            text: 'Create Quick List',
            link: '/dv/list-view/?newTab=create-quick',
            target: '_self',
          },
        ],
      };

      // Recently Created section
      const recentlyCreatedSection = {
        id: 'recently-created-section',
        text: 'Recently Created',
        items: mapListViewItems(recentlyCreated),
      };

      // Recently Opened section
      const recentlyOpenedSection = {
        id: 'recently-opened-section',
        text: 'Recently Opened',
        items: mapListViewItems(recentlyOpened),
      };

      const listViewTabs = {
        sortPosition: 4,
        id: 'list-view',
        text: 'List View',
        img: '/dv/images/app-icons/ListView_small.png',
        sections: [newListViewSection, recentlyCreatedSection, recentlyOpenedSection],
      };
      this.tabs.push(listViewTabs);

      this.request('/dvsvc/LvListFavorites', 'GET').then((resp) => {
        if (resp?.IsError) {
          this.notifyDanger('Error: LvListFavorites service');
          return;
        }

        const { sections } = this.tabs.find((tab) => tab.id === 'list-view');
        const favoritesSection = {
          id: 'favorites-lists',
          text: 'Favorites',
          items: resp
            .sort((a, b) => {
              const firstListName = a.ListName;
              const lastListName = b.ListName;

              return firstListName.localeCompare(lastListName);
            })
            .map((fav) => {
              return {
                id: fav.ListID,
                text: fav.ListName,
                link: `/dv/list-view/?lid=${fav.ListID}`,
                target: '_self',
              };
            }),
        };
        sections.splice(1, 0, favoritesSection);
      });
    },
    createScoutingTabs() {
      const sections = [];

      // Schedule ----------------------------------------
      const scheduleSection = {
        id: 'scheduling',
        text: 'scheduling',
        items: [
          {
            id: 'schedule',
            text: 'Schedule App',
            link: '/dv/schedule/',
            target: '_self',
          },
        ],
      };
      sections.push(scheduleSection);

      // Scouting ----------------------------------------

      const scoutingItems = [];

      if (this.canAccessTonto) {
        const proTonto = {
          id: 'tonto-pro',
          text: 'Pro Scouting',
          link: '/dv/scouting_new/dashboard?t=1',
          target: '_self',
        };
        scoutingItems.push(proTonto);

        const amTonto = {
          id: 'tonto-amateur',
          text: 'Amateur Scouting',
          link: '/dv/scouting_new/dashboard?t=0',
          target: '_self',
        };
        scoutingItems.push(amTonto);

        const intlTonto = {
          id: 'tonto-intl',
          text: 'International Scouting',
          link: '/dv/scouting_new/dashboard?t=2',
          target: '_self',
        };
        scoutingItems.push(intlTonto);
      }

      const scoutingSection = {
        id: 'scouting',
        text: 'Scout View',
        items: scoutingItems,
      };

      sections.push(scoutingSection);

      const scoutingTabs = {
        sortPosition: 5,
        id: 'scouting',
        text: 'Scout View',
        img: '/dv/images/ClevelandPro_Logo.svg',
        sections: sections,
      };

      // Utilities -------------------------------------
      const utilitiesSection = {
        id: 'utilities-scouting',
        text: 'utilities',
        items: [
          {
            id: 'mu-video',
            text: 'Video Mass Uploader',
            link: '/dv/scouting_new/mass-uploader/videos',
            target: '_self',
          },
          {
            id: 'mu-journal',
            text: 'Journal Entry Mass Uploader',
            link: '/dv/scouting_new/mass-uploader/journal-entries',
            target: '_self',
          },
          {
            id: 'mu-external-links',
            text: 'External Links Mass Uploader',
            link: '/dv/scouting_new/mass-uploader/external-links',
            target: '_self',
          },
        ],
      };

      if (this.canAccessDraftTools) {
        utilitiesSection.items.unshift({
          id: 'mu-draft-tools',
          text: 'Draft Tools',
          link: '/dv/scouting_new/draft-tools?t=0',
          target: '_self',
        });
      }

      const playerMatcherNavItem = {
        id: 'data-matcher',
        text: 'Data Matcher',
        link: '/dv/scouting_new/data-matcher',
        target: '_self',
      };

      if (this.canMatchPlayers) utilitiesSection.items.push(playerMatcherNavItem);

      sections.push(utilitiesSection);

      this.tabs.push(scoutingTabs);
    },
    createGamesTabs() {
      const sections = [];
      // Civid -----------------------------------------
      const cividSection = {
        id: 'civid',
        text: 'Civid',
        items: [
          {
            id: 'home-page',
            text: 'Civid Home Page',
            link: '/dv/civid/index.html',
            target: '_self',
          },
        ],
      };

      sections.push(cividSection);

      // Box Scores --------------------------------------
      const boxScoresSection = {
        id: 'box-score',
        text: 'Box Scores',
        items: [
          {
            id: 'box-scores',
            text: 'Box Scores',
            link: '/dv/livescore/',
            target: '_self',
          },
        ],
      };
      sections.push(boxScoresSection);

      // Gameview ------------------------------------------
      const gameViewSection = {
        id: 'gameview',
        text: 'Game View',
        items: [
          {
            id: 'game-view-home',
            text: 'Game View',
            link: '/dv/gameview',
            target: '_self',
          },
        ],
      };
      if (this.canAccessFxwOBAfxFIP) sections.push(gameViewSection);

      if (this.liveGames) {
        // todays live games ---------------------------------
        const orderedToday = this.liveGames.Games.filter((g) => g.IsToday).sort((a, b) => a.Lev - b.Lev);

        const todayItems = orderedToday.map((g) => {
          return {
            id: `${g.GameId}-${g.PitcherId}`,
            text: g.GameDesc,
            link: `/dv/gameview#/pitch?GameId=${g.GameId}&PitcherId=${g.PitcherId}`,
            target: '_self',
          };
        });

        const todaySection = {
          id: 'today-live',
          text: "Today's Live Games",
          items: todayItems,
        };

        sections.push(todaySection);
      }

      // Games ----------------------------------------
      const gameItems = [
        {
          id: 'game-finder',
          text: 'Game Finder',
          link: '/dv/games/',
          target: '_self',
        },
        {
          id: 'iscore',
          text: 'iScore Cut Sheets',
          link: '/dv/games/iscore.html',
          target: '_self',
        },
      ];
      const gameTabsSection = {
        id: 'game-links',
        text: 'Game Tabs',
        items: gameItems,
      };
      sections.push(gameTabsSection);

      if (this.cleLastGamesData) {
        // Recent Game Video ---------------------------------------------
        const orderedRec = this.cleLastGamesData.Games.sort((a, b) => a.TeamLevelRank - b.TeamLevelRank);
        const recItems = orderedRec.map((g) => {
          return {
            id: `${g.GameId}-${g.TeamId}`,
            text: g.MenuText,
            link: '/dv/civid/game.html?i=' + g.GameId,
            target: '_self',
          };
        });
        const recGamesSection = {
          id: 'rec-games',
          text: 'Recent Game Video',
          items: recItems,
        };

        sections.push(recGamesSection);
      }
      if (this.liveGames) {
        // yesterdays live games ---------------------------------
        const orderedYest = this.liveGames.Games.filter((g) => !g.IsToday).sort((a, b) => a.Lev - b.Lev);
        const yestItems = orderedYest.map((g) => {
          return {
            id: `${g.GameId}-${g.PitcherId}`,
            text: g.GameDesc,
            link: `/dv/gameview#/pitch?GameId=${g.GameId}&PitcherId=${g.PitcherId}`,
            target: '_self',
          };
        });

        const yestSection = {
          id: 'yest-live',
          text: "Yesterday's Live Games",
          items: yestItems,
        };

        sections.push(yestSection);
      }

      const gamesTabs = {
        sortPosition: 6,
        id: 'games',
        text: 'Game View',
        img: '/dv/images/app-icons/Civid_small.png',
        sections: sections,
      };
      this.tabs.push(gamesTabs);
    },
    createOptionsLink() {
      const sections = [];

      if (this.securityEdit) {
        const securitySection = {
          id: 'security',
          text: 'DV Security',
          items: [
            {
              id: 'assing-roles',
              text: 'Assign Roles To Users',
              clickFunc: this.openSecurityModalRoles,
            },
            {
              id: 'assing-permissions',
              text: 'Assign Permissions To Users',
              clickFunc: this.openSecurityModalPerm,
            },
            {
              id: 'view-permissions',
              text: 'View Effective Permissions By User',
              clickFunc: this.openSecurityModalView,
            },
          ],
        };
        sections.push(securitySection);
      }
      if (this.opsViewer) {
        const bbDashSection = {
          id: 'bb-dash',
          text: 'BB Dash',
          items: [
            {
              id: 'dashboard',
              text: 'Dashboard',
              link: '/dv/ops/bbdash.html',
              target: '_blank',
            },
            {
              id: 'db-docs',
              text: 'DB Documentation',
              link: '/dv/ops/db_docs.html',
              target: '_blank',
            },
            {
              id: 'airflow',
              text: 'Airflow',
              link: 'https://oe15742f6a4ff0008p-tp.appspot.com/home',
              target: '_blank',
            },
            {
              id: 'powerbi',
              text: 'Power BI',
              link: '/dv/ops/powerbi.html',
              target: '_blank',
            },
          ],
        };
        sections.push(bbDashSection);
      }

      const optionsTabs = {
        sortPosition: 7,
        id: 'options',
        text: 'Options',
        img: '/dv/images/app-icons/Dev_small.png',
        sections: sections,
      };

      this.tabs.push(optionsTabs);
    },
    mapListViewLists(lists) {
      const mappedLists = lists.reduce(
        (prev, list) => {
          const { Category } = list;

          Category === 'Recently Created' && prev.recentlyCreated.push(list);
          Category === 'Recently Opened' && prev.recentlyOpened.push(list);
          Category === 'My Private Lists' && prev.myLists.push(list);

          return prev;
        },
        { recentlyCreated: [], recentlyOpened: [], myLists: [] },
      );

      const sortListsByLoadDate = (lists) => {
        return lists.sort((list1, list2) => {
          const { LoadDt: list1Date } = list1;
          const { LoadDt: list2Date } = list2;
          const list1Dt = moment(list1Date);
          const list2Dt = moment(list2Date);

          if (list1Dt.isBefore(list2Dt)) return -1;
          if (list1Dt.isAfter(list2Dt)) return 1;

          return 0;
        });
      };

      mappedLists.recentlyCreated = sortListsByLoadDate(mappedLists.recentlyCreated).slice(0, 8);
      mappedLists.recentlyOpened = sortListsByLoadDate(mappedLists.recentlyOpened).slice(0, 5);
      mappedLists.myLists = sortListsByLoadDate(mappedLists.myLists).slice(0, 8);

      return mappedLists;
    },

    openSecurityModalRoles() {
      // assign roles
      this.$refs.securityModal.open(0);
    },
    openSecurityModalPerm() {
      // assign permissions
      this.$refs.securityModal.open(1);
    },
    openSecurityModalView() {
      // view permissions
      this.$refs.securityModal.open(2);
    },
  },
};
</script>

<style scoped lang="scss">
@import 'dv/lib/SASS/_vars.scss';
$universal_search_margin: 10px;
$small_nav_width: calc(100vw / 11);
$xs_nav_width: 640px;

#mainNav {
  height: $mainNavHeight;
  width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;

  background-color: $scouting-gray;

  font-size: 12px;
  .hide-mobile {
    @media screen and (max-width: $break-medium) {
      display: none;
    }
  }
  .contain-nav-item {
    max-height: 100%;
  }
  @media screen and (max-width: $xs_nav_width) {
    .contain-nav-item {
      width: 100%;

      &.nav-right-section-wrapper {
        width: fit-content;
      }
    }
  }
  .nav-right-section-wrapper {
    display: flex;
    align-items: stretch;
    align-self: stretch;
    min-height: 100%;
    @media screen and (max-width: $break-medium) {
      width: calc(3 * $small_nav_width);
    }
    .nav-right-section {
      display: flex;
      align-items: center;
      align-self: stretch;
      min-height: 100%;
    }
  }

  #dv-title {
    display: flex;
    flex-direction: row;
    border-right: 1px solid lighten($scouting-gray, 10%);
    align-items: center;
    min-width: 175px;
    text-align: center;
    padding: 10px;
    color: white;
    svg {
      width: 25px;
      height: 40px;
      margin-right: 5px;
      fill: white;
      cursor: pointer;
    }
    #dv-user-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-grow: 1;
      a {
        width: 100%;
        font-family: 'TribeType_DV';
        color: white;
        font-size: 15px;
        text-shadow: 0.07407em 0.07407em #003263;
      }
      span {
        margin-top: 3px;
        color: $dvYellow;
        font-size: 1em;
      }
    }
    @media screen and (max-width: $break-medium) {
      max-width: $small_nav_width;
      min-width: 0px;
      padding: 5px;
      #dv-user-container {
        display: none;
      }
      svg {
        margin-right: 0px;
      }
    }

    @media screen and (max-width: $xs_nav_width) {
      svg {
        max-width: 18px;
      }
    }

    @media screen and (max-width: $xs_nav_width) {
      max-width: fit-content;
    }
  }

  #nav-tabs {
    display: inline-flex;
    flex-direction: row;
    align-items: stretch;
    padding-right: 10px;
    @media screen and (max-width: $break-medium) {
      padding-right: 0px;
      :deep(.dropdown-container) {
        width: $small_nav_width;
        .nav-tab {
          justify-content: center;
          img {
            margin-right: 0px;
          }
        }
      }
    }

    @media screen and (max-width: $xs_nav_width) {
      :deep(.dropdown-container) {
        width: fit-content;
        padding: 2px;
        border-right: 1px solid #a8b0bd;

        .nav-tab {
          border-right: none;
        }
      }
    }
  }

  #dv-universal-search {
    align-self: center;
    margin: 0 $universal_search_margin;
    z-index: 10;
    width: fit-content;

    @media screen and (max-width: $break-medium) {
      margin: 0;
      :deep(.search) {
        position: static;
        input {
          max-width: 100%;
        }
        .drop-down {
          width: 100vw;
          position: absolute;
          min-width: 0px;
          .multitoggle {
            flex-wrap: wrap;
          }
        }
      }
    }
  }

  #the-feed-button {
    :deep(#feedButton) {
      position: relative;
      right: unset;
      margin: 0px;
    }
  }

  #dv-logout-button {
    display: flex;
    cursor: pointer;
    align-items: center;
    @media screen and (max-width: $break-medium) {
      margin: 0;
      width: $small_nav_width;
      justify-content: center;
    }
    @media screen and (max-width: $xs_nav_width) {
      width: fit-content;
    }
    margin: 0 10px 0 5px;
    img {
      min-width: 20px;
      width: 30px;
      max-width: 100%;
      height: auto;
    }
  }

  .dv2-link-scoutview {
    display: flex;
    align-self: stretch;
    align-items: center;
    justify-content: center;
    min-height: 100%;

    a {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      min-height: 100%;
      padding: 0 12px;
      color: #fff;
      font-size: 13px;
      text-decoration: none;
      background: linear-gradient(226.11deg, rgba(0, 0, 0, 0.07) 0%, rgba(0, 0, 0, 0.15) 100%);
      border-left: 1px solid rgba(255, 255, 255, 0.22);
      box-shadow: inset 3px 0px 2px -2px rgba(0, 0, 0, 0.3);

      &:hover {
        background: linear-gradient(226.11deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.22) 100%);
      }

      /* Asset is 31×11; full nav-height scaling (~44px) blows the mark up ~4×. Cap height, keep tall tap target on `a`. */
      img {
        width: auto;
        height: auto;
        max-height: calc(#{$mainNavHeight} - 18px);
        max-width: 120px;
        object-fit: contain;
        display: block;
      }
    }

    @media screen and (max-width: $break-medium) {
      a {
        padding: 0 8px;
      }
    }
  }
}
</style>
